<template>
 <div class="newscenter">
  <div class="newscenter-title newscenter_box">新闻中心</div>
  <div class="newscenter-content newscenter_box">
   <a-tabs v-model:activeKey="activeKey" :centered="true">
    <a-tab-pane v-for="item in dataList" :key="item.rowId" class="animate__animated animate__slideInRight">
     <template #tab>
      <div class="newscenter-content-tab-item">
       <img :src="getImgUrl(item)" alt="" style="width: 23px; height: 23px;">
       <span>{{ item.name }}</span>
      </div>
     </template>
     <div class="newscenter-content-tab-item-content">
      <div v-for="val in getList(item['associationFields589c8f25'])" style="cursor: pointer;" :key="val.rowId"
       @click="toDetail(val)" class="newscenter-content-tab-item-content-box">
       <div class="newscenter-content-tab-item-content-box-img">
        <img :src="getImgUrl_val(val)" alt="" style="width: 100%;">
       </div>
       <div class="newscenter-content-tab-item-content-box-content">
        <div class="newscenter-content-tab-item-content-box-content-title">{{ val.input988275a1 }}</div>
        <div class="newscenter-content-tab-item-content-box-content-jianjie">{{ val.input25fa7d87 }}</div>
        <div class="newscenter-content-tab-item-content-box-content-date">
         <span class="newscenter-content-tab-item-content-box-content-date-date">{{ val.date2f1ad95c }}</span>
         <span class="newscenter-content-tab-item-content-box-content-date-tag">{{ val.inputbce97e78 }}</span>
        </div>
       </div>

      </div>
     </div>
    </a-tab-pane>
    <template #renderTabBar="{ DefaultTabBar, ...props }">
     <component :is="DefaultTabBar" v-bind="props" />
    </template>
   </a-tabs>
  </div>
  <div class="newscenter-pagination newscenter_box">
   <learnmore path="/news"></learnmore>
  </div>
 </div>
 <div class="newscenter-mobile">
  <div class="newscenter-title newscenter_box">新闻中心</div>
  <div class="newscenter-mobile-content">
   <a-tabs v-model:activeKey="activeKey" :centered="true">
    <a-tab-pane v-for="item in dataList" :key="item.rowId" class="animate__animated animate__slideInRight">
     <template #tab>
      <div class="newscenter-content-tab-item-mobile">
       <img :src="getImgUrl(item)" alt="" style="width: 23px; height: 23px;">
       <span>{{ item.name }}</span>
      </div>
     </template>
     <div class="newscenter-content-tab-item-content-mobile">
      <div v-for="val in getList(item['associationFields589c8f25'])" style="cursor: pointer;" :key="val.rowId"
       @click="toDetail(val)" class="newscenter-content-tab-item-content-box-mobile">
       <div class="newscenter-content-tab-item-content-box-img-mobile">
        <img :src="getImgUrl_val(val)" alt="" style="width: 100%;height: 100%;">
       </div>
       <div class="newscenter-content-tab-item-content-box-content">
        <div class="newscenter-content-tab-item-content-box-content-title-mobile">{{ val.input988275a1 }}</div>
        <div class="newscenter-content-tab-item-content-box-content-title-mobile-jianjie">{{ val.input25fa7d87 }}</div>
        <div class="newscenter-content-tab-item-content-box-content-date">
         <span class="newscenter-content-tab-item-content-box-content-date-date">{{ val.date2f1ad95c }}</span>
         <!-- <span class="newscenter-content-tab-item-content-box-content-date-tag">{{ val.inputbce97e78 }}</span> -->
        </div>
       </div>

      </div>
     </div>
    </a-tab-pane>
    <template #renderTabBar="{ DefaultTabBar, ...props }">
     <component :is="DefaultTabBar" v-bind="props" />
    </template>
   </a-tabs>
  </div>
  <div class="newscenter-pagination newscenter_box">
   <learnmore path="/news"></learnmore>
  </div>
 </div>
</template>

<script setup>
import learnmore from "@/components/learnmore.vue"
import newscenterCard from "./components/newscenterCard.vue"
import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import { useRouter } from 'vue-router'
import ScrollReveal from 'scrollreveal'


const router = useRouter()

const dataList = ref([])

const activeKey = ref('2');

const getImgUrl = (item) => {
 if (item['picture-upload7281d024'] && item['picture-upload7281d024'].length > 0) {
  return item['picture-upload7281d024'][0].url
 } else {
  return ""

 }
}
const getImgUrl_val = (item) => {
 if (item['picture-uploadc1d6988a'] && item['picture-uploadc1d6988a'].length > 0) {
  return item['picture-uploadc1d6988a'][0].url
 } else {
  return ""

 }
}

const getList = (item) => {
 if (item && item.length > 4) {
  item.sort(function (a, b) {
   return b.number52288da3 - a.number52288da3;
  });
  return item.slice(0, 4)
 } else {
  return item
 }
}
// 
const getData = async () => {
 let params = {
  page: 1,
  pageSize: 10000,
  sortField: "number9bfa1bf1",
  isAsc: false,
  worksheetId: "6809e61bec5e343d1ca49cea",
 }
 const res = await getFilterList(params)
 if (res.code === 200 && res.data && res.data.length > 0) {
  console.log(res.data);
  activeKey.value = res.data[0].rowId
  dataList.value = res.data
 }
}


const toDetail = (item) => {
 router.push({
  path: '/news',
  query: {
   id: item.rowId
  }
 })
}
onMounted(() => {
 getData()
 const sr = ScrollReveal({
  distance: '50px',
  duration: 1000,
  delay: 300,
 })

 // 为每个元素配置不同的动画
 sr.reveal(".newscenter_box", {
  beforeReveal: (el) => {
   el.classList.add('animate__fadeInUp')
  },
 })
})
</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .newscenter {
  display: none !important;
 }

 .newscenter-mobile {
  display: flex !important;
 }
}



@media screen and (min-width: 800px) {
 .newscenter {

  display: flex !important;
 }

 .newscenter-mobile {
  display: none !important;
 }
}

.newscenter,
.newscenter-mobile {
 font-family: 'PuHuiTi';
 width: 100%;
 height: 800px;
 display: flex;
 flex-direction: column;
 align-items: center;
}

.newscenter-mobile {
 height: 100%;
}

.newscenter-content {
 width: 1400px;
 height: 600px;
 border-radius: 10px;
}

.newscenter-title {
 font-size: 36px;
 font-weight: 500;
 color: #333333;
 margin: 30px 0;
}

.newscenter-pagination {
 display: flex;
 flex-direction: column;
 align-items: center;
}

.newscenter-content {
 width: 1400px;
}

.newscenter-content-item {
 width: 180px;
 height: 93px;
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 background: #FFFFFF;
 box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, .1);
 border-radius: 4px;
}

.newscenter-content-tab-item {
 display: flex;
 align-items: center;
 font-size: 20px;
 margin: 0 50px;

 img {
  margin-right: 10px;
 }
}

.newscenter-content-tab-item-content {
 padding-top: 20px;
 width: 100%;
 height: 100%;
 display: flex;
 flex-wrap: wrap;
 justify-content: flex-start;
}

.newscenter-content-tab-item-content-box {
 width: 45%;
 height: 190px;
 margin: 25px 20px;
 display: flex;
 align-items: center;
 padding: 20px 20px;
 box-shadow: 0px 1px 5px 0px rgba(185, 196, 218, .4);
 border-radius: 5px;
}

.newscenter-content-tab-item-content-box:hover {
 box-shadow: 0px 2px 8px 0px rgba(185, 196, 218, 0.80);

}

.newscenter-content-tab-item-content-box-img {
 width: 260px;
 height: 130px;
 padding: 10px 0;
 border-radius: 5px;
 overflow: hidden;

 img {
  border-radius: 7px;
 }
}

.newscenter-content-tab-item-content-box-content {
 width: 56%;
 height: 100%;
 display: flex;
 flex-direction: column;
 justify-content: space-around;
 margin-left: 20px;
}

.newscenter-content-tab-item-content-box-content-title {
 font-size: 18px;
 overflow: hidden;
 text-overflow: ellipsis;
 white-space: nowrap;
}

.newscenter-content-tab-item-content-box-content-jianjie {
 height: 62px;

 -webkit-line-clamp: 3;
 /* 限制显示两行 */
 overflow: hidden;
 /* 隐藏超出范围的内容 */
 text-overflow: ellipsis;
 white-space: wrap;
 font-size: 14px;
}

.newscenter-content-tab-item-content-box-content-date {
 display: flex;
 justify-content: space-between;
 align-items: end;
}

.newscenter-content-tab-item-content-box-content-date-date {
 color: #989DA7;
 overflow: hidden;
 text-overflow: ellipsis;
 white-space: nowrap;
}

.newscenter-content-tab-item-content-box-content-date-tag {
 background: rgba(32, 129, 235, 0.1);
 padding: 2px 10px;
 max-width: 120px;
 border-radius: 3px;
 overflow: hidden;
 text-overflow: ellipsis;
 white-space: nowrap;

}

.newscenter-mobile-content {
 width: 100%;
}

.newscenter-content-tab-item-mobile {
 width: 100%;
}

.newscenter-content-tab-item-content-box-mobile {
 height: 150px;
 margin: 10px 20px;
 display: flex;
 align-items: center;
 padding: 20px 20px;
 box-shadow: 0px 1px 5px 0px rgba(185, 196, 218, .4);
 border-radius: 5px;
}

.newscenter-content-tab-item-content-box-img-mobile {
 width: 150px;
 height: 100px;
}

.newscenter-content-tab-item-content-box-content-title-mobile {
 display: -webkit-box;
 /* 设置为WebKit内核的弹性盒子模型 */
 -webkit-box-orient: vertical;
 /* 垂直排列 */
 -webkit-line-clamp: 2;
 /* 限制显示两行 */
 overflow: hidden;
 /* 隐藏超出范围的内容 */
 text-overflow: ellipsis;
 font-size: 16px;
}

.newscenter-content-tab-item-content-box-content-title-mobile-jianjie {
 display: -webkit-box;
 /* 设置为WebKit内核的弹性盒子模型 */
 -webkit-box-orient: vertical;
 /* 垂直排列 */
 -webkit-line-clamp: 2;
 /* 限制显示两行 */
 overflow: hidden;
 /* 隐藏超出范围的内容 */
 text-overflow: ellipsis;
 font-size: 14px;
}
</style>